<template>

    <form action="https://minsteadtrust.us11.list-manage.com/subscribe/post?u=232ea26e1caee2b12ca82e569&amp;id=d1ad6813a8" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" ref="form">
        <div class="d-flex flex-wrap align-items-end justify-content-center mlg-d-block">
            <div class="form-group">
                <label for="mce-FNAME" class="c-white form-group-label">First name</label>
                <input type="text" name="FNAME" id="mce-FNAME" class="input-text" required>
            </div>
            <div class="form-group">
                <label for="mce-LNAME" class="c-white form-group-label">Last name</label>
                <input type="text" name="LNAME" id="mce-LNAME" class="input-text" required>
            </div>
            <div class="form-group">
                <label for="mce-EMAIL" class="c-white form-group-label required">Email address</label>
                <input type="email" name="EMAIL" id="mce-EMAIL" class="input-text" required>
            </div>
            <div class="form-group">
                <button class="btn --white mlg-w-100" type="submit">Subscribe</button>
            </div>
        </div>
    </form>

</template>

<script>

    export default {
        name: 'NewsletterForm',

        data() {
            return {
                form: {
                    first_name: '',
                    last_name: '',
                    email: '',
                }
            }
        },

        methods: {
            submit() {
                //
            }
        }
    }

</script>
